<template>
  <div class="navigation">

    <div class="navigation__logo">
      PhishAR &times; X.FER
      <span></span>
    </div>
    <ul class="navigation__links">
      <li>
        <a href="#register">Prijave</a>
      </li>
    </ul>

  </div>
</template>
<script>
export default {}
</script>
